import BoardScreen from "@/pages/BoardScreen";

const SEED = [
    { name: "Build Queue", color: "#FF5500" },
    { name: "In Fabrication", color: "#FFEA00" },
    { name: "QA & Sea Trials", color: "#2979FF" },
    { name: "Delivered", color: "#00E676" },
];

export default function Production() {
    return (
        <BoardScreen
            board="production"
            code="AO/03"
            title="Production"
            subtitle="Build queue, manufacturing status, sea trials."
            seedGroups={SEED}
        />
    );
}
